import { useState, useEffect, useReducer } from 'react'
import { Switch, Route, useParams } from 'react-router-dom'

import { Flex } from '../../../../primitives'

import Plan from '../Plan'
import Table from './Table'
import Form from './Form'
import HarvestDataboard from './Databoard'

import { tableReducer, tableInitialState } from './state'

const MODULE_PATH = '/operations/:zone+/harvest'

function Harvest() {
  const params = useParams()

  const [state, dispatchState] = useReducer(tableReducer, tableInitialState)

  const [modulePath, setModulePath] = useState(MODULE_PATH)

  useEffect(() => {
    if (params?.zone) {
      setModulePath(MODULE_PATH.replace(':zone+', params.zone))
    }
  }, [params?.zone])

  return (
    <Flex axisGap={400} direction='column'>
      <Switch>
        <Route path={`${MODULE_PATH}/plans`}>
          <Plan
            organizations={state.organizations}
            sites={state.sites}
            backPath={modulePath}
          />
        </Route>
        <Route
          path={[`${MODULE_PATH}/create`, `${MODULE_PATH}/update/:itemId`]}
          exact={true}
        >
          <Form
            state={state}
            dispatchState={dispatchState}
            modulePath={modulePath}
          />
        </Route>
        <Route path={`${MODULE_PATH}/data`} exact={true}>
          <HarvestDataboard />
        </Route>
        <Route path={MODULE_PATH} exact={true}>
          <Table
            state={state}
            dispatchState={dispatchState}
            modulePath={modulePath}
          />
        </Route>
      </Switch>
    </Flex>
  )
}

export default Harvest
